module.exports = __webpack_public_path__ + "assets/img/202109-2W.081aa599.png";